export { default } from './TableColumnTitle'
